<template>
    <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.2638 2L2 11M2 2L4.65623 4.89286M6.13191 6.5L10.2638 11" stroke="black" stroke-opacity="0.5"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>